module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.86c03c0.eot";